module.exports = __webpack_public_path__ + "img/03-BABO-01.662829d3.png";